import { ModalType } from 'containers/types/modal.types';

// Types

type ShowModalAction = {
  type: 'MODAL_SHOW';
  payload: {
    type: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props: Record<string, any>;
  };
};
type HideModalAction = {
  type: 'MODAL_HIDE';
};
export type Action = ShowModalAction | HideModalAction;

// Reducer

const initialState = {
  type: null,
  props: {},
};
export type State = {
  type: ModalType | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any>;
};

// eslint-disable-next-line import/no-default-export
export default function modalReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = initialState,
  action: Action
) {
  switch (action.type) {
    case 'MODAL_SHOW':
      return {
        ...state,
        type: action.payload.type,
        props: action.payload.props,
      };

    case 'MODAL_HIDE':
      return initialState;

    default:
      return state;
  }
}

// Actions

export const showModal = (
  type: ModalType,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any> = {}
): ShowModalAction => ({
  type: 'MODAL_SHOW',
  payload: {
    type,
    props,
  },
});
export const hideModal = (): HideModalAction => ({
  type: 'MODAL_HIDE',
});
